export default __webpack_public_path__ + "static/media/ambient-bright-red.9a8e0cc9.jpg";